import { Box } from "@mui/material";
import { SeasonalDataDescriptionLeft } from "./SeasonalDataDescriptionLeft";
import { SeasonalDataDescriptionRight } from "./SeasonalDataDescriptionRight";
import { Dispatch, SetStateAction } from "react";

interface validationProps {
  setLeftValidate: Dispatch<SetStateAction<() => boolean>>;
  setRightValidate: Dispatch<SetStateAction<() => boolean>>;
  nextClicked: boolean;
  setNextClicked: Dispatch<SetStateAction<boolean>>;
}

export const SeasonalDataDescription = ({
  setLeftValidate,
  setRightValidate,
  nextClicked,
  setNextClicked,
}: validationProps) => {
  return (
    <Box
      display="grid"
      gridTemplateColumns={{
        xs: "1fr ",
        sm: "1fr",
        md: "1fr",
        lg: "1fr 1fr",
      }}
      height="16.5rem"
      overflow="auto"
    >
      <SeasonalDataDescriptionLeft
        setLeftValidate={setLeftValidate}
        nextClicked={nextClicked}
        setNextClicked={setNextClicked}
      />
      <SeasonalDataDescriptionRight
        setRightValidate={setRightValidate}
        nextClicked={nextClicked}
        setNextClicked={setNextClicked}
      />
    </Box>
  );
};
